import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type ProjectTemplateApplierType from './ui/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export default lazyForPaint<typeof ProjectTemplateApplierType>(
	() => import(/* webpackChunkName: "async-polaris-lib-project-template-applier" */ './ui'),
	{ ssr: false },
);
